<svg class="stacked-area-chart"></svg>

<div id="stacked-area-chart-tooltip">
  <p>{{ 'sp.revamp.assetGraph.tooltipText.expected' | translate }} {{ (tooltipData.expected.toFixed(0)) | thousand: currency }}</p>
  <p>{{ 'sp.revamp.assetGraph.tooltipText.gain' | translate }} {{ (tooltipData.potential.toFixed(0)) | thousand: currency }}</p>
  <p>{{ 'sp.revamp.assetGraph.tooltipText.loss' | translate }} {{ (tooltipData.loss.toFixed(0)) | thousand: currency }}</p>
  <ion-icon name="info-filled" (click)="openExpectedExplanation()"></ion-icon>
</div>

<div class="timeline">
  <div>
    <b>{{currentYear}}</b>
    <span>{{ 'sp.revamp.3a.graph.now' | translate }}</span>
  </div>
  <div>
    <span>{{timeToRetirement}} {{ 'sp.revamp.3a.graph.' + (timeToRetirement > 1 ? 'years':'year') | translate }}</span>
  </div>
  <div>
    <b>{{retirementYear}}</b>
    <span>{{ 'sp.revamp.3a.graph.retirement' | translate }}</span>
  </div>
</div>

<h3>{{ 'sp.revamp.3a.deposits.title' | translate }}</h3>
<div class="stacked-area-chart__legend">
  <div
    class="stacked-area-chart__legend-item"
    *ngFor="let item of ['expectedCaseWithout','expectedCase']; let i = index"
    (click)="switchSelection(i); track(i)"
    [class.inactive]="currentChip !== i"
  >
    {{ 'sp.revamp.assetGraph.' + (i === 0 ? 'monthly' : 'yearly') | translate }}
  </div>
</div>
<div class="no-deposit">
  <span class="rectangle"></span>
  <span
    [innerHTML]="'sp.revamp.3a.noDeposits.text' | translate:{value:estimatedValues.expectedWithout.toFixed(0) | thousand: currency}"
  ></span>
</div>
